import { useTranslation } from 'react-i18next';
import TitleBar from '../utils/TitleBar.js';

const GuiDing_Alarms = {
    1: "High Voltage Switch Alarm", 
    2: "Low Voltage Switch Alarm", 
    3: "Smoke Sensor Alarm", 
    5: "Electric Heating Protection", 
    6: "Indoor High Temperature Alarm", 
    7: "Indoor Low Temperature Alarm", 
    8: "Indoor High Humidity Alarm", 
    9: "Indoor Low Humidity Alarm", 
    10: "Condensation Temperature Too High", 
    11: "Evaporation Temperature Too Low", 
    12: "Indoor Temperature Sensor Fault", 
    13: "Indoor Humidity Sensor Fault", 
    14: "Condensation Temperature Fault", 
    15: "Evaporation Temperature Fault", 
    18: "Forced Cooling Room Temperature Too Low", 
    19: "Forced Heating Room Temperature Too High", 
    23: "Supply Air Temperature Fault", 
    24: "Ambient Temperature Fault", 
    26: "Condensation Temperature Warning", 
    27: "Evaporation Temperature Warning", 
    28: "Water Leakage Alarm", 
    29: "Compressor Current Too High", 
    30: "Electric Heating Current Too High", 
}

const GuiDing_Switchs = {
    31: "Supply Fan", 
    32: "Compressor", 
    33: "Electric Heating", 
    34: "Outdoor Fan", 
    35: "Fault Output", 
}

const GuiDing_Analog = {
    1: "Indoor Humidity", 
    2: "Indoor Temperature", 
    3: "Condensation/Liquid Supply Temperature", 
    4: "Evaporation/Supply Air Temperature", 
    5: "Supply Air/Outdoor Temperature", 
}

function AirGuiDing({data}) {
    const { t } = useTranslation();

    if (!data || !data.CoilData) {
        return;
    }

    const vs = [];

    const cd = data.CoilData;
    const ln = Object.keys(GuiDing_Alarms).length + Object.keys(GuiDing_Switchs).length;
    const xs = {...GuiDing_Alarms, ...GuiDing_Switchs}
    for (const k in xs) {
        const bk = Math.floor(parseInt(k)/ 8);
        const bitk = parseInt(k) % 8;
        const v = (cd[bk] >> bitk)&1;
        let vStr = t("Normal");
        if (v == 1){
            if (k <= 30) {
                vStr = t("Alarm Or Fault")
            } else {
                vStr = t("On")
            }
        } else if ( k > 30) {
            vStr = t("Off")
        }
        vs.push({
            Name: xs[k],
            Value: vStr
        })
    }

    const rd = data.RegisterData
    for (const k in GuiDing_Analog) {
        const i = parseInt(k) - 1;
        let v = (parseInt(rd[2*i]) << 8) + parseInt(rd[2*i+1]);
        if (v > 0x7fff) {
            v -= 0xffff + 1;
        }
        v /= 10;
        vs.push({
            Name: GuiDing_Analog[k],
            Value: v.toFixed(1),
        })
    }

    return (
        <div style={{padding: '10px 15px'}}>
            <TitleBar title={t('Air-Conditioner')} data={data} />
            <div style={{marginTop: '20px'}}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: '#f0f0f0', width: '100%',height: '270px', borderRadius: '10px',  padding: '4px 4px'
                }}>
                    <div style={{flex: 1, display: "flex", flexDirection: "column"}}>
                        {vs.slice(0,17).map((v)=>{
                            return <div style={{fontSize: '9px'}}>{t(v.Name)}: {v.Value}</div>
                        })}
                    </div>
                    <div style={{flex: 1, display: "flex", flexDirection: "column"}}>
                        {vs.slice(17).map((v)=>{
                            return <div style={{fontSize: '9px'}}>{t(v.Name)}: {v.Value}</div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AirGuiDing; 